module.exports = __webpack_public_path__ + "img/연합뉴스.1bdc439f.png";